import http, { createApi } from '@core/fetch'

export default {
  // 已经认证通过之后的获取和编辑
  merchantInfo: createApi('/p/wedding/index.php/Admin/APIMerchant/edit'),

  postEdit: createApi.post('/p/wedding/index.php/Admin/APIMerchant/edit'),

  //获取团队、认证信息
  getGroupInfo: () => http('/p/wedding/admin/APIMerchant/mainMerchantData'),

  creatSiYi: body =>
    http.post('/p/wedding/admin/APIMerchant/createMainMerchant', { body })
}
